export const ease = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.85, ease } },
};

export const stagger = {
  show: { transition: { staggerChildren: 0.12 } },
};

export const viewport = { once: true, margin: "-70px" };
